module.exports = "pegasus/assets/blocks/column-8-theme6.png";